import { render, staticRenderFns } from "./newPrintList.vue?vue&type=template&id=4b37178d&scoped=true&"
import script from "./newPrintList.vue?vue&type=script&lang=js&"
export * from "./newPrintList.vue?vue&type=script&lang=js&"
import style0 from "./newPrintList.vue?vue&type=style&index=0&id=4b37178d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b37178d",
  null
  
)

export default component.exports